import React from "react";
import { useInView } from "react-intersection-observer";

import { BiComment } from "@react-icons/all-files/bi/BiComment";
import { AiTwotoneLike } from "@react-icons/all-files/ai/AiTwotoneLike";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";
import { AiOutlineLike } from "@react-icons/all-files/ai/AiOutlineLike";
import { AiFillFlag } from "@react-icons/all-files/ai/AiFillFlag";

import Loadinguser from "../../../../components/Loadingnovel";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import Replie from "./Replie";
import { getUpdatedComment } from "../../../../3- actions/comments";

function ViewReplies({
  allComments,
  setCommentId,
  setReportId,
  setReplyUserId,
  setReportPopUp,
  setReplie2XCommentPopUp,
  currentNovel,
  allCommentUsers,
  userId,
  currentComment,
  repliesPopup,
  setRepliesPopUp,
  setReplieCommentPopUp,
  commentId,
  setReplyCommentId,
  setPopUp,
  setInterfaces,
}) {
  const dispatch = useDispatch();
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });
  const localuser = JSON.parse(localStorage.getItem("profile"));
  const commentLikes = currentComment?.[0]?.likes;

  // give me all reply comments so i can manipulate it
  const replyCommentsList = allComments?.comments?.filter(
    (comment) => comment.Replie_id === commentId
  );
  const usersList = allCommentUsers?.users?.filter(
    (Usercomment) => Usercomment?._id === userId
  );

  const handleClickRejectReport = () => {
    if (localuser) {
      setReportPopUp(true);
    } else {
      setRepliesPopUp(false);
      setReportPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  const handleClickReject = () => {
    if (localuser) {
      setReplieCommentPopUp(true);
    } else {
      setReplieCommentPopUp(false);
      setRepliesPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  const handleClickRejectList = () => {
    if (localuser) {
      setReplie2XCommentPopUp(true);
    } else {
      setReplie2XCommentPopUp(false);
      setRepliesPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  const handleClickRejectList2 = () => {
    if (localuser) {
      setReplieCommentPopUp(true);
      setReplyCommentId(commentId);
    } else {
      setReplie2XCommentPopUp(false);
      setRepliesPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };

  const handleClickLikes = () => {
    if (localuser) {
      // push to User_id to my old array
      if (commentLikes?.includes(localuser?.result?._id)) {
        const commentDataLikesObject = {
          userId: currentComment?.[0]._id,
          obj: {
            likes: commentLikes.filter(
              (like) => like !== localuser?.result?._id
            ),
          },
        };
        dispatch(getUpdatedComment(commentDataLikesObject));
      } else {
        const commentDataLikesObject = {
          userId: currentComment?.[0]._id,
          obj: {
            likes: [...commentLikes, localuser?.result?._id],
          },
        };
        dispatch(getUpdatedComment(commentDataLikesObject));
      }
    } else {
      setRepliesPopUp(false);
      setInterfaces(
        0,
        setTimeout(() => {
          setPopUp(true);
        }, 10)
      );
    }
  };
  function numbersLogic(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }

    return num;
  }
  return (
    <div>
      {/* repliesPopup */}
      <div
        onClick={() => setRepliesPopUp(false)}
        className={
          repliesPopup
            ? "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      <div
        className={
          repliesPopup
            ? "-translate-y-[0%] opacity-100 w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
            : "translate-y-[200%] opacity-0 w-full md:w-full lg:w-[75%] xl:w-[60%]  2xl:w-[50%] h-full md:h-[80%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
        }
      >
        <div className="w-full md:w-full lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className="relative md:static overflow-y-scroll z-[1000] w-full md:w-full lg:w-full xl:w-full 2xl:w-full h-full md:h-full bg-tertiary duration-500 ease-in-out">
            <div className="w-full">
              <div>
                <h2 className="px-[15px] md:px-16 pt-28 md:pt-16 font-size">
                  Review details
                </h2>
                {/* Reply Comment */}
                <div className="px-[15px] md:px-16 pt-10 pb-14">
                  {currentComment?.map((comment) => {
                    return (
                      <div
                        ref={ref}
                        key={comment._id}
                        onClick={() => setReplyCommentId(comment._id)}
                        className=" text-secondary "
                      >
                        <div className="flex justify-between items-center">
                          <div className="flex justify-center items-center gap-x-4">
                            <Link to={`/users/${comment.User_id}`}>
                              <div className="w-[45px] h-[45px] md:w-[50px] md:h-[50px]">
                                {inView ? (
                                  <div className="w-full h-full opacity-100 duration-500 ease-in-out">
                                    {usersList?.[0]?.picture === "" ? (
                                      <div
                                        title={usersList?.[0]?.firstName}
                                        className="cursor-pointer capitalize w-12 h-12 text-tertiary bg-primary rounded-full relative z-[50] flex justify-center items-center"
                                      >
                                        {usersList?.[0]?.firstName?.[0]}
                                      </div>
                                    ) : (
                                      <img
                                        title={usersList?.[0]?.firstName}
                                        className="w-full h-full cursor-pointer object-cover rounded-full"
                                        src={usersList?.[0]?.picture}
                                        alt={usersList?.[0]?.firstName}
                                      />
                                    )}
                                  </div>
                                ) : (
                                  <div className="flex justify-center items-center h-full w-full rounded-full opacity-20 scale-90 rectangle duration-[0] ease-in-out object-cover">
                                    <Loadinguser />
                                  </div>
                                )}
                              </div>
                            </Link>
                            <div className="flex flex-wrap justify-start items-center gap-x-4">
                              <div>
                                <Link
                                  title={usersList?.[0]?.firstName}
                                  to={`/users/${comment.User_id}`}
                                  className="flex-1 capitalize line line-clamp-1 font-SoraS  cursor-pointer text-[15px] md:text-[16px]"
                                >
                                  {usersList?.[0]?.firstName}
                                </Link>
                              </div>
                              {/* if comment User_id equal currentNovel User_id/creator */}
                              {currentNovel.User_id === comment?.User_id && (
                                <div className="bg-primary text-tertiary  duration-500 ease-in-out hover:bg-primary/90 px-6 py-1 relative">
                                  <h2 className="capitalize text-[13px]">
                                    Author
                                  </h2>
                                  <div className="h-[10px] w-[10px] bg-white rounded-full absolute top-0 right-0 -translate-y-1/2 translate-x-1/2">
                                    <div className="h-[10px] w-[10px] bg-white animate-ping rounded-full absolute inset-0 "></div>
                                  </div>
                                </div>
                              )}
                              <div
                                data-tip
                                data-for={comment?.User_id}
                                className="relative flex justify-center items-center "
                              >
                                <span>
                                  <ReactTooltip
                                    id={comment?.User_id}
                                    className="custom-color-no-arrow"
                                    delayHide={100}
                                    textColor="#D9D9D9"
                                    backgroundColor="#1d1d1d"
                                    effect="solid"
                                  >
                                    <span>{usersList?.[0]?.badgeName}</span>
                                  </ReactTooltip>
                                </span>
                                <span>
                                  <div
                                    className="zoombadge opacity-100 rounded-full blur-[40px]"
                                    dangerouslySetInnerHTML={{
                                      __html: usersList?.[0]?.badgeSvg,
                                    }}
                                  />
                                </span>
                                <span>
                                  <div
                                    className="zoombadge absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                    dangerouslySetInnerHTML={{
                                      __html: usersList?.[0]?.badgeSvg,
                                    }}
                                  />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div>
                            <h5 className="md:block hidden uppercase font-SoraL text-[13px] md:text-[16px]">
                              {moment(comment.createdAt).fromNow()}
                            </h5>
                          </div>
                        </div>
                        <div className="w-full md:mt-[10px] mt-[10px] mb-[20px] md:mb-[30px] font-SoraR flex gap-x-0 md:gap-x-4">
                          <div className="w-0 md:w-[50px]"></div>
                          <p className="text-[14px] break-words w-[90%] flex-1 md:text-[16px] font-SoraR">
                            {comment.comment.trim()}
                          </p>
                        </div>
                        <div className="flex gap-x-0 md:gap-x-4 mb-[20px] md:mb-[30px]">
                          <div className="w-0 md:w-[50px]"></div>
                          <div className="flex justify-between w-full">
                            <div className="block md:hidden">
                              <span className="uppercase font-SoraL text-[13px] line-clamp-1">
                                {moment(comment.createdAt).fromNow()}
                              </span>
                            </div>
                            {/* to make flex justify between */}
                            <div></div>
                            <div className="flex gap-x-4 md:gap-x-6 items-center">
                              <div
                                onClick={handleClickLikes}
                                title="Like"
                                className={
                                  commentLikes?.includes(localuser?.result?._id)
                                    ? "text-primary duration-500 ease-in-out cursor-pointer flex justify-center items-center gap-x-[5px] md:gap-x-[10px] flex-row-reverse"
                                    : "text-secondary hover:text-primary duration-500 ease-in-out cursor-pointer flex justify-center items-center gap-x-[5px] md:gap-x-[10px] flex-row-reverse"
                                }
                              >
                                <span className="text-[13px] md:text-[16px]">
                                  {numbersLogic(comment?.likes?.length)}
                                </span>
                                <div>
                                  {commentLikes?.includes(
                                    localuser?.result?._id
                                  ) ? (
                                    <AiTwotoneLike className="md:scale-125 scale-100 " />
                                  ) : (
                                    <AiOutlineLike className="md:scale-125 scale-100 " />
                                  )}
                                </div>
                              </div>
                              <div
                                onClick={handleClickReject}
                                title="Comment"
                                className="hover:text-primary duration-500 ease-in-out cursor-pointer flex justify-center items-center gap-x-[10px] flex-row-reverse"
                              >
                                <span className="sm:hidden block text-[13px] md:text-[16px]">
                                  {numbersLogic(replyCommentsList?.length)}
                                </span>
                                <BiComment className=" md:scale-125 scale-100 " />
                              </div>
                              <div
                                onMouseUp={() => {
                                  setReportId(comment._id);
                                }}
                              >
                                <div
                                  className="group hover:text-primary duration-500 ease-in-out cursor-pointer"
                                  data-for="global4"
                                  data-tip="custom show and hide"
                                  data-event="click"
                                  data-event-off="dblclick"
                                >
                                  <div
                                    title="Report"
                                    className="group flex gap-x-[4px] md:gap-x-[5px] py-2"
                                  >
                                    <span className="group-hover:bg-primary duration-500 ease-in-out  md:w-[4px] w-[3px] h-[3px] md:h-[4px] bg-secondary"></span>
                                    <span className="group-hover:bg-primary duration-500 ease-in-out  md:w-[4px] w-[3px] h-[3px] md:h-[4px] bg-secondary"></span>
                                    <span className="group-hover:bg-primary duration-500 ease-in-out  md:w-[4px] w-[3px] h-[3px] md:h-[4px] bg-secondary"></span>
                                  </div>
                                  <div onMouseDown={handleClickRejectReport}>
                                    <Report />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-x-0 md:gap-x-4">
                          <div className="w-0 md:w-[50px]"></div>
                          <div className="w-full h-[1px] bg-secondary/20"></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* replies */}
              <div className="relative bg-primarys w-full h-full">
                <div className="bg-primarys w-full h-full absolute bottom-0 left-0 Purple-full-width -z-10"></div>
                <div className="px-[15px] md:px-16 py-16">
                  <div>
                    <h3 className="font-size">
                      {numbersLogic(replyCommentsList?.length)} replies
                    </h3>
                  </div>
                  <div>
                    {replyCommentsList?.map((comment) => {
                      return (
                        <div key={comment._id}>
                          <Replie
                            setReportId={setReportId}
                            setCommentId={setCommentId}
                            setReportPopUp={setReportPopUp}
                            allComments={allComments}
                            allCommentUsers={allCommentUsers}
                            comment={comment}
                            setReplyCommentId={setReplyCommentId}
                            setReplyUserId={setReplyUserId}
                            handleClickRejectList={handleClickRejectList}
                            setPopUp={setPopUp}
                            currentNovel={currentNovel}
                            setInterfaces={setInterfaces}
                            setRepliesPopUp={setRepliesPopUp}
                          />
                        </div>
                      );
                    })}
                    {replyCommentsList?.length === 0 ? (
                      <div>
                        <div className="flex justify-center items-center mt-[100px]">
                          <p className="text-[14px] md:text-[16px] capitalize font-SoraL text-center">
                            No replies to display. be the first one to ever
                            replie!
                          </p>
                        </div>
                      </div>
                    ) : null}
                    <div className="pb-28 md:pb-16 pt-6">
                      <div
                        title="Write A Reply Comment"
                        onClick={handleClickRejectList2}
                        className=" bg-tertiary hover:bg-tertiary/90 duration-500 ease-in-out cursor-pointer flex justify-center items-center h-[63px] max-w-[420px] m-auto w-full"
                      >
                        <div className="flex px-2 gap-x-4 justify-center items-center">
                          <h2 className="line-clamp-1 text-[14px] md:text-[16px] capitalize text-primary font-SoraR">
                            Write a reply comment
                          </h2>
                          <Arrow className="flex-none" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={() => setRepliesPopUp(false)}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewReplies;

function Arrow() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{
          width: "1em",
          height: "1em",
          verticalAlign: "middle",
          fill: "currentColor",
          overflow: "hidden",
        }}
        className="svg-icon text-primary text-[20px]"
        viewBox="0 0 1024 1024"
        version="1.1"
      >
        <path
          d="M0 524.8l281.6 166.4 582.4-531.2L384 704l384 128 256-832zM384 985.6L512 832l-128-64z"
          fill=""
        />
      </svg>
    </div>
  );
}
function Report() {
  return (
    <ReactTooltip
      id="global4"
      className="extraClass custom-color-no-arrow"
      delayHide={500}
      globalEventOff="click"
      place="left"
      textColor="#D9D9D9"
      backgroundColor="#6947EF"
      effect="solid"
    >
      <div className="max-w-[220px] z-[100000000] flex justify-center items-center gap-x-2 p-2 text-[13px] sm:text-[14px]">
        <AiFillFlag className=" scale-90 md:scale-110" />
        <h3 className="font-SoraR text-[12px] md:text-[15px]">
          Report Comment
        </h3>
      </div>
    </ReactTooltip>
  );
}
